import axios from '../utils/axiosClient';
import endpoints from './endpoints';

const { getPublishedFaq } = endpoints;

const fetchPublishedFaq = async () => {
  try {
    const response = await axios.get(getPublishedFaq);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const faqService = {
  fetchPublishedFaq,
};

export default faqService;
